import callApi from "helpers/callApi";

/** Legacy bulk notification center payload. */
export function getNotificationCenter(params = {}) {
  return callApi("/notify/notification_center", "GET", {
    only_active: true,
    ...params,
  });
}

export function getNotificationCenterTable(tableId, params = {}) {
  const safeId = encodeURIComponent(String(tableId ?? "").trim());
  return callApi(`/notify/notification_center/${safeId}`, "GET", {
    only_active: true,
    ...params,
  });
}

export function getNotificationCenterCounters(params = {}) {
  return callApi("/notify/notification_center/counters", "GET", params);
}
